export const ChooseFiles4Organize = {
  "Action": {
    "remove": "Remove",
    "add": "Add"
  },
  "Title": {
    "watermark": "Watermark",
    "background": "Background",
    "headerfooter": "Header and Footer",
    "batesNumbering": "Bates Numbering",
    "sign": "Sign Multiple Documents"
  },
  "FullTitle": "{action} {title}",
  "OutputOptionsBtn": "Output Options...",
  "AddFiles": "Add Files",
  "TotalFiles": "Total {count} File(s)",
  "ArrangeFiles": "Arrange Your Files",
  "Table": {
    "Name": "Name",
    "Local": "Local",
    "Size": "Size",
    "Modified": "Modified"
  },
  "MoveUp": "Move Up",
  "MoveDown": "Move Down",
  "Remove": "Remove",
  "ErrFileAlreadyExist": "This file already exists, there is no need to choose it again.",
  "OutputOptions": {
    "Title": "Output Options",
    "FileNaming": "File Naming",
    "KeepOriginal": "Keep original file names",
    "AddOriginal": "Add to original file names:",
    "TipTitle": "File Name",
    "TipContent": "File re-naming is not possible if you are outputting to an ECM (i.e. iManage, SharePoint, etc.)",
    "InsertBefore": "Insert Before",
    "InsertAfter": "Insert After",
    "OriginalName": "+ original file name +"
  },
  "ErrorFileFormat": "Invalid file format.",
  "ErrorFileExist": "This file already exists, there is no need to choose it again.",
  "ErrorNoPermission": "You don't have sufficient permissions to access the document.",
  "SuccessRemove": "{title} has been successfully removed from {successCnt} of {total} PDF files.",
  "SuccessAdd": "{title} has been successfully applied to {successCnt} of {total} PDF files.",
  "SignSummery": "Signature successfully applied to {successCnt} of {total} PDF files.",
  "WarningHint": "Download only with success status.",
  "WarningsAndError": "Warnings and Errors",
  "SignNow": "Sign Immediately",
  "SignError": {
    "Success": "Succeeded",
    "Failed": "Failed.",
    "NoPage": "No corresponding page.",
    "OutOfRange": "Signature is out of page area",
    "NoSignature": "No signature field"
  }
}